<div class="container-fluid glb-popup" id="emailTemplate">
  <h2>{{ formTitle }}</h2>
  <!-- <div class="d-flex" > -->
  @for (maintenanceEvent of maintenanceEventList; track maintenanceEvent; let i = $index) {
    <button  pButton style="text-decoration: underline;" class="btn-cancel p-button-text" (click)="fetchMaintenanceEventByMaintenanceEventId(maintenanceEvent)"><h5>Event-{{i+1}}</h5></button>
  }
<!-- </div> -->
<p-toast [style]="{ marginTop: '80px' }"> </p-toast>
<p-confirmDialog
  header="Confirmation"
  icon="pi pi-exclamation-triangle"
></p-confirmDialog>

<button
  mat-icon-button
  [mat-dialog-close]="true"
  style="float: right; top: -50px; background-color: transparent"
  >
  <i class="pi pi-times" aria-hidden="true"></i>
</button>
<hr />
<div [formGroup]="form1" class="forms w-100 d-block">
  <div class="row m-0">
    <div class="col-lg-12">
      @if (formAlert) {
        <div class="w-100 mb-3">
          <div
            class="w-100"
            style="
              text-align: center;
              background-color: yellow;
              padding: 5px;
              margin-bottom: 15px;
            "
            >
            <p>
              <b>{{ formAlert }}</b>
            </p>
          </div>
        </div>
      }
    </div>

    <div class="col-lg-12">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="name" id="name" type="text" pInputText />
        <label for="name">Name</label>
        @for (validation of validationMessages.name; track validation) {
          <span>
            @if (
              form1.get('name').hasError(validation.type) &&
              (form1.get('name').dirty || form1.get('name').touched)
              ) {
              <small
                class="p-invalid"
                >{{ validation.message }}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-12">
      <label for="description"><strong>Public Description for Website :</strong></label>
      <span class="p-float-label w-100 mb-3">
          <editor formControlName="description" id="description" [init]="{
      										selector: 'textarea#open-source-plugins',
      			  plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
      			  editimage_cors_hosts: ['picsum.photos'],
      										height: 400,
      										base_url: '/tinymce',
      										suffix: '.min',
      										menubar: 'file edit view insert format tools table tc help',
      			  toolbar: 'undo redo | aidialog aishortcuts | blocks fontsizeinput | bold italic | align numlist bullist | link image | table media pageembed | lineheight  outdent indent | strikethrough forecolor backcolor formatpainter removeformat | charmap emoticons checklist | code fullscreen preview | save print export | pagebreak anchor codesample footnotes mergetags | addtemplate inserttemplate | addcomment showcomments | ltr rtl casechange | spellcheckdialog a11ycheck',
      			  autosave_ask_before_unload: true,
      			  autosave_interval: '30s',
      			  autosave_prefix: '{path}{query}-{id}-',
      			  autosave_restore_when_empty: false,
      			  autosave_retention: '2m',
      			  image_advtab: true,
      			  link_list: [
      			    { title: 'My page 1', value: 'https://s3.us-east-1.amazonaws.com/img.kbmblog.com/' },
      			    { title: 'My page 2', value: 'https://s3.us-east-1.amazonaws.com/img.kbmblog.com/' }
      			  ],
      			  image_class_list: [
      			    { title: 'None', value: '' },
      			    { title: 'Some class', value: 'class-name' }
      			  ],
      			  importcss_append: true,
      			  template_cdate_format: '[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]',
      			  template_mdate_format: '[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]',
      			  image_caption: true,
      			  quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
      			  noneditable_class: 'mceNonEditable',
      			  toolbar_mode: 'sliding',
      			  contextmenu: 'link image table',
      			  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }'
      									}">
        </editor>
        @for (validation of validationMessages.description; track validation) {
          <span>
            @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-12">
      <span class="p-float-label required-field w-100 mb-3">
        <textarea formControlName="impactDesc" id="impactDesc" [rows]="2" pInputTextarea></textarea>
        <label for="impactDesc">Impact Description</label>
        @for (validation of validationMessages.impactDesc; track validation) {
          <span>
            @if (
              form1.get('impactDesc').hasError(validation.type) &&
              (form1.get('impactDesc').dirty ||
              form1.get('impactDesc').touched)
              ) {
              <small
                class="p-invalid"
                >{{ validation.message }}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-12">
      <span class="p-float-label required-field w-100 mb-3">
        <textarea formControlName="resolutionDesc" id="resolutionDesc" [rows]="2" pInputTextarea></textarea>
        <label for="resolutionDesc">Resolution Description</label>
        @for (validation of validationMessages.resolutionDesc; track validation) {
          <span>
            @if (
              form1.get('resolutionDesc').hasError(validation.type) &&
              (form1.get('resolutionDesc').dirty ||
              form1.get('resolutionDesc').touched)
              ) {
              <small
                class="p-invalid"
                >{{ validation.message }}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown
          class="w-100"
          [options]="resolutions"
          formControlName="resolution"
          optionLabel="name"
          optionValue="value"
          placeholder="Resolution"
        ></p-dropdown>
        <label for="resolution">Resolution</label>
        @for (validation of validationMessages.resolution; track validation) {
          <span>
            @if (
              form1.get('resolution').hasError(validation.type) &&
              (form1.get('resolution').dirty ||
              form1.get('resolution').touched)
              ) {
              <small
                class="p-invalid"
                >{{ validation.message }}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-12">
      <span class="p-float-label required-field w-100 mb-3">
        <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
        <label for="opsNotes">Operational Notes</label>
        @for (validation of validationMessages.opsNotes; track validation) {
          <span>
            @if (
              form1.get('opsNotes').hasError(validation.type) &&
              (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)
              ) {
              <small
                class="p-invalid"
                >{{ validation.message }}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <p-calendar
          formControlName="startDate"
          inputId="startDate"
          appendTo="body"
          >
        </p-calendar>
        <label for="startDate">Start Date</label>
        @for (validation of validationMessages.startDate; track validation) {
          <span>
            @if (
              form1.get('startDate').hasError(validation.type) &&
              (form1.get('startDate').dirty || form1.get('startDate').touched)
              ) {
              <small
                class="p-invalid"
                >{{ validation.message }}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <p-calendar
          formControlName="endDate"
          inputId="endDate"
          appendTo="body"
          >
        </p-calendar>
        <label for="endDate">End Date</label>
        @for (validation of validationMessages.endDate; track validation) {
          <span>
            @if (
              form1.get('endDate').hasError(validation.type) &&
              (form1.get('endDate').dirty || form1.get('endDate').touched)
              ) {
              <small
                class="p-invalid"
                >{{ validation.message }}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <!-- <mat-form-field class="col-lg-6">
    <mat-label>Start Time</mat-label>
    <mat-select [(value)]="form1.value.startTime" formControlName="startTime">
      <mat-option *ngFor="let i of time" [value]="i.value"> {{i.name}} </mat-option>
    </mat-select>
    <mat-error *ngFor="let validation of validationMessages.startTime">
      <mat-error class="error-message"
        *ngIf="form1.get('startTime').hasError(validation.type) && (form1.get('startTime').dirty || form1.get('startTime').touched)">
      {{validation.message}}</mat-error>
    </mat-error>
  </mat-form-field>

  <mat-form-field class="col-lg-6">
    <mat-label>End Time</mat-label>
    <mat-select [(value)]="form1.value.endTime" formControlName="endTime">
      <mat-option *ngFor="let i of time" [value]="i.value"> {{i.name}} </mat-option>
    </mat-select>
    <mat-error *ngFor="let validation of validationMessages.endTime">
      <mat-error class="error-message"
        *ngIf="form1.get('endTime').hasError(validation.type) && (form1.get('endTime').dirty || form1.get('endTime').touched)">
      {{validation.message}}</mat-error>
    </mat-error>
  </mat-form-field> -->

  @if (maintenanceEventId) {
    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <input
          formControlName="status"
          id="status"
          type="text"
          pInputText readonly="true"
          />
        <label for="status">Status</label>
        @for (validation of validationMessages.status; track validation) {
          <span>
            @if (
              form1.get('status').hasError(validation.type) &&
              (form1.get('status').dirty || form1.get('status').touched)
              ) {
              <small
                class="p-invalid"
                >{{ validation.message }}
              </small>
            }
          </span>
        }
      </span>
    </div>
  }

  <!-- <div class="col-lg-12">
  <h6 for="strOrFloor">Maintenance Event Places</h6>
  <div class="flex align-items-center">
    <p-radioButton [formControl]="form1.controls['strOrFloor']" inputId="shortTermRentalRadio"
    name="strOrFloor" value="str" [(ngModel)]="strOrFloor">Short Term Rental(s)</p-radioButton>
  </div>
  <div class="flex align-items-center">
    <p-radioButton [formControl]="form1.controls['strOrFloor']" inputId="floorOfPropertyRadio"
    name="strOrFloor" value="floor" [(ngModel)]="strOrFloor">Floor(s) Of Property</p-radioButton>
  </div>
</div> -->

@if (strOrFloor == 'floor') {
  <div class="col-lg-12 mb-3">
    <span [formGroup]="form1">
      <p-multiSelect class="lead-select" [options]="properties" formControlName="maintenanceEventShortTermRentalAPIList" appendTo="body"
      defaultLabel="Select Property" optionLabel="propertyCode" [displaySelectedLabel]="true"></p-multiSelect>
      @for (validation of validationMessages.maintenanceEventShortTermRentalAPIList; track validation) {
        <span>
          @if (form1.get('maintenanceEventShortTermRentalAPIList').hasError(validation.type) && (form1.get('maintenanceEventShortTermRentalAPIList').dirty || form1.get('maintenanceEventShortTermRentalAPIList').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (maintenanceEventId) {
  <div
    style="padding-bottom: 20px"
    class="col-lg-12"
    >
    <app-maintenance-event-shorttermrental-list
      [maintenanceEventId]="maintenanceEventId"
      [showFilter]="false"
      [showPagination]="false"
      [outlineNewButton]="false"
    ></app-maintenance-event-shorttermrental-list>
  </div>
}

<div class="col-lg-12">
  <span class="p-float-label w-100 mb-3">
    <p-dropdown [options]="developments" formControlName="developmentId" optionLabel="addressDevelopmentName" appendTo="body"
      optionValue="developmentId" [filter]="true" filterBy="addressDevelopmentName" [showClear]="false"
      placeholder="Select Development">
    </p-dropdown>
    <label for="developmentId">Select Development</label>
    @for (validation of validationMessages.developmentId; track validation) {
      <span>
        @if (form1.get('developmentId').hasError(validation.type) && (form1.get('developmentId').dirty || form1.get('developmentId').touched)) {
          <small class="p-invalid"
            >{{validation.message}}
          </small>
        }
      </span>
    }
  </span>
</div>

@if (strOrFloor == 'floor') {
  <div class="col-lg-12">
    <span class="p-float-label required-field w-100 mb-3">
      <input
        formControlName="floorOfProperty"
        id="floorOfProperty"
        type="text"
        pInputText
        />
      <label for="floorOfProperty">Floor(s) of Property</label>
      @for (validation of validationMessages.floorOfProperty; track validation) {
        <span>
          @if (
            form1.get('floorOfProperty').hasError(validation.type) &&
            (form1.get('floorOfProperty').dirty ||
            form1.get('floorOfProperty').touched)
            ) {
            <small
              class="p-invalid"
              >{{ validation.message }}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

<div class="col-lg-12">
  <span class="p-float-label required-field w-100 mb-3">
    <input
      formControlName="adrBuildingName"
      id="adrBuildingName"
      type="text"
      pInputText
      />
    <label for="adrBuildingName">Building Name</label>
    @for (validation of validationMessages.adrBuildingName; track validation) {
      <span>
        @if (
          form1.get('adrBuildingName').hasError(validation.type) &&
          (form1.get('adrBuildingName').dirty ||
          form1.get('adrBuildingName').touched)
          ) {
          <small
            class="p-invalid"
            >{{ validation.message }}
          </small>
        }
      </span>
    }
  </span>
</div>

<div class="col-lg-12">
  <span class="p-float-label w-100 mb-3">
    <p-dropdown
      class="w-100" appendTo="body"
      [options]="visibilities"
      formControlName="visibility"
      optionLabel="name"
      optionValue="value"
      placeholder="Visibility"
    ></p-dropdown>
    <label for="visibility">Visibility</label>
    @for (validation of validationMessages.visibility; track validation) {
      <span>
        @if (
          form1.get('visibility').hasError(validation.type) &&
          (form1.get('visibility').dirty ||
          form1.get('visibility').touched)
          ) {
          <small
            class="p-invalid"
            >{{ validation.message }}
          </small>
        }
      </span>
    }
  </span>
</div>



</div>
</div>
<hr />
<div class="row m-0">
  <div class="col-lg-12">
    <div class="btn-group" style="padding-bottom: 20px">
      <div class="button-group">
        @if (maintenanceEventId) {
          <button pButton class="btn-delete p-button-outlined p-button-danger"
          (click)="onFormDelete()">Delete MaintenanceEvent</button>
        }
      </div>

      <div class="button-group">
        <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
        @if (!maintenanceEventId) {
          <button pButton class="btn-addt p-button" (click)="formAdd()">Add MaintenanceEvent</button>
        }

        @if (maintenanceEventId) {
          <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update MaintenanceEvent</button>
        }
      </div>
    </div>
  </div>
</div>
</div>
